import { inject, Injectable } from '@angular/core';

import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { AlertController } from '@ionic/angular';

import { EmailComposer, OpenOptions } from 'capacitor-email-composer';

@Injectable({
  providedIn: 'root'
})
export class EmailComposerService {
  private alertController = inject(AlertController);

  async composeEmail(options: OpenOptions) {
    if (Capacitor.isNativePlatform()) {
      const { hasAccount } = await EmailComposer.hasAccount();
      if (hasAccount) {
        await EmailComposer.open(options);
      } else {
        const alert = await this.alertController.create({
          buttons: [
            {
              role: 'cancel',
              text: 'Ok'
            }
          ],
          header: 'Oops',
          message: "We can't open the email composer since no email account is configured on this device."
        });
        await alert.present();
      }
    } else {
      await Browser.open({
        url: `mailto:${options.to}?cc=${options.cc?.join(';')}&to=${options.to?.join(';')}&subject=${options.subject ? encodeURIComponent(options.subject) : ''}&body=${options.body ? encodeURIComponent(options.body) : ''}`,
        windowName: '_blank'
      });
    }
  }
}
